import { type FC } from 'react'
import {
  useClearRefinements,
  type UseClearRefinementsProps,
} from 'react-instantsearch'
import { FormattedMessage } from 'react-intl'

import { IconTrashDelete } from '@redteclab/icons'

import { Button, type ButtonProps } from 'base-ui'

type ProductSearchRefinementClearRefinementProps = ButtonProps &
  Pick<UseClearRefinementsProps, 'includedAttributes'> & {
    onResetFilter?: () => void
  }

export const ProductSearchRefinementClearRefinement: FC<
  ProductSearchRefinementClearRefinementProps
> = ({ includedAttributes, onResetFilter, ...restProps }) => {
  const { canRefine, refine } = useClearRefinements({
    includedAttributes,
  })

  const handleResetClick = (): void => {
    if (onResetFilter) {
      onResetFilter()
    }

    refine()
  }

  return (
    <Button
      {...restProps}
      disabled={!canRefine}
      onClick={handleResetClick}
      size="medium"
      startIcon={
        <IconTrashDelete className={canRefine ? 'fill-dark-brand' : ''} />
      }
      variant="text"
    >
      <FormattedMessage id="searchResults.label.clearFilter" />
    </Button>
  )
}
